'use client';

import clsx from 'clsx';
import Link from 'next/link';
import { CommonLocals } from '@pioz/mlm-common';
import { NavigationHref } from '@pioz/mlm-common/types';
import { useActiveLinkState } from './use-active-link-state';

interface NavLink {
  href: NavigationHref;
  label: string;
}

export function TabNavigation({
  locale,
  links,
  className,
  linkClass,
  linkActiveClass,
}: {
  locale: CommonLocals;
  links: NavLink[];
  className?: string;
  linkClass?: string;
  linkActiveClass?: string;
}) {
  return (
    <div role="tablist" className={clsx('tabs tabs-border', className)}>
      {links.map((link) => (
        <TabLink
          {...link}
          key={link.href}
          locale={locale}
          linkClass={linkClass}
          linkActiveClass={linkActiveClass}
        />
      ))}
    </div>
  );
}

interface NavLinkProps extends NavLink {
  locale: CommonLocals;
  linkClass?: string;
  linkActiveClass?: string;
}

function TabLink({ locale, href, label, linkClass, linkActiveClass }: NavLinkProps) {
  const isActive = useActiveLinkState({
    href,
    locale,
    onlyExactHrefActive: true,
  });

  return (
    <Link
      replace
      className={clsx('tab', linkClass, isActive && 'tab-active', isActive && linkActiveClass)}
      href={href}
      role="tab"
    >
      {label}
    </Link>
  );
}
